import { feedbackRibbonStore } from '../store/store';

export default function getFeedbackRibbonState(id: string) {
    return feedbackRibbonStore.mountedRibbons.get(id);
}
